import { render, staticRenderFns } from "./OPOS.vue?vue&type=template&id=a0b927d6&"
import script from "./OPOS.vue?vue&type=script&lang=ts&"
export * from "./OPOS.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports